module.exports = __webpack_public_path__ + "static/filmmaker-dadc318b2015ee303beae6f563fe0a1b.jpg";